import React from 'react';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/react-hooks';
import { useIntl } from 'react-intl';
import { ADD_INTERESTS } from './mutations';
import { growlActionSuccess } from '../../../utils/NotificationUtil';
import { withGrowl } from '../../../components/GrowlNotifications';
import { growlShape } from '../../../components/prop-types';
import messages from './intl-messages';

const ActivateInterests = ({
  sourceAccountId, targetAccountId, growl, fetchData,
}) => {
  const [addInterests] = useMutation(ADD_INTERESTS);
  const intl = useIntl();

  return (
    <>
      <Button
        type="button"
        className="p-button-secondary"
        icon="pi pi-lock-open"
        label={intl.formatMessage(messages.addInterests)}
        onClick={async () => {
          await addInterests({
            variables: {
              input: {
                sourceAccountId,
                targetAccountId,
              },
            },
          })
            .then(() => {
              growlActionSuccess(growl, intl.formatMessage(messages.addInterestsSuccess));
              fetchData();
            })
            .catch(() => {
              growl.show({ severity: 'error', detail: intl.formatMessage(messages.addInterestsError), sticky: true });
            });
        }}
      />
    </>
  );
};

ActivateInterests.propTypes = {
  sourceAccountId: PropTypes.number.isRequired,
  targetAccountId: PropTypes.number.isRequired,
  growl: growlShape.isRequired,
  fetchData: PropTypes.func.isRequired,
};

export default withGrowl(ActivateInterests);
